module.exports = __webpack_public_path__ + "static/word-medicine.d3055de6.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-medicine.png
// module id = 996
// module chunks = 2